module.exports = __webpack_public_path__ + "static/media/tachometer-alt-fast.7d6c1411.svg";